import React from "react";
import Wrapper from "./CheckboxStyled";

const Checkbox = ({
  onFocus,
  onBlur,
  onChange,
  checked,
  name,
  title,
  mr,
  isAlignRight,
  disabled,
}) => {
  return (
    <Wrapper className="container" mr={mr}>
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={`checkmark ${isAlignRight && "tf-right"}`}></span>
      {title}
    </Wrapper>
  );
};

export default Checkbox;
